module.exports = __webpack_public_path__ + "img/SM6_MASK_M.163aba55.png";